<template>
   <LoadingContainer 
      :isLoading="loading" 
      :hasError="error"
      :hasNoResults="audit.length === 0"
      errorMessage="Audit history could not be retrieved."
      noResultsMessage="No audit history available."
      color="alt-1"
    >
    <div class="note-list">
      <div
        v-for="(auditEntry, index) in audit"
        :key="index"
      >
        <div class="col-md-12 content-list mb-1">
          <b>Audit Entry:</b>
          <span>{{ extractLocalDateTimeFromContent(auditEntry.content, auditEntry.createdOn) }}</span>
        </div>
        <div class="col-md-12 content-list mb-2">
          <b>Created on:</b>
          <span class="created-on-text">{{ localDateTime(auditEntry.createdOn) }}</span>
        </div>
      </div>
    </div>
  </LoadingContainer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import LoadingContainer from '../../layout/LoadingContainer';

export default {
    name: 'Audit',
    components: {
      LoadingContainer
    },
    data: function() {
      return {
        loading: true,
        error: false
      }
    },
    computed: {
      ...mapState({
        audit: state => state.booking.audit,
      }),
      ...mapGetters(['getSelectedAirportTimeZone'])
    },
    methods: {
        localDateTime(dateTime, alternateFormat) {
            var utcDateTime = moment.utc(dateTime.slice(0, 16));
            var localDateTime = utcDateTime.tz(this.getSelectedAirportTimeZone).format(alternateFormat || 'DD MMM YYYY HH:mm');
            return localDateTime;
        },
        extractLocalDateTimeFromContent(contentString, createdDate) {
            const potentialDateTimeString = contentString.slice(contentString - 16);
            if (!moment(potentialDateTimeString, 'DD/MM/YYYY HH:mm').isValid()) {
                return contentString;
            }

            const content = contentString.substring(0, contentString.length - 16);
            const localCreatedDate = this.localDateTime(createdDate, 'DD/MM/YYYY HH:mm');
            return `${content} ${localCreatedDate}`;
        }
    },
    async created() {
      this.loading = true;
      try {
        await this.$store.dispatch('getAudit', this.$route.params.bookingId);
      } catch {
        this.error = true;
      }
      this.loading = false;
    }
}
</script>

<style lang="scss" scoped>
.full-width {
    width: 100%;
}
.created-on-text {
  font-size: 0.8em
}
</style>
